import { GET_CARD_SUGGESTS } from '../types';

export default function getSuggests(cardNumber) {
  return function(dispatch, getState) {
    const {
      common: {
        cardSuggests: { items },
      },
    } = getState();

    dispatch({
      suggests: items.filter(card => card.bin.startsWith(cardNumber)),
      type: GET_CARD_SUGGESTS,
    });
  };
}
